import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estatusCertificado: [],
  },

  getters: {
    getEstatusCertificado: (state) => state.estatusCertificado,
  },

  mutations: {
    SET_ESTATUS_CERTIFICADO(state, estatusCertificado) {
      state.estatusCertificado = estatusCertificado;
    },
  },

  actions: {
    async fetchEstatusCertificado({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catestatusCertificado')
        .then((response) => {
          commit('SET_ESTATUS_CERTIFICADO', response.data.data);
        });
    },
  },
};
